import { validator } from '../core'

export const confirmPasswordValidation = (name: string, ref) => {
  return validator
    .string()
    .required(`${name} is required.`)
    .oneOf([ref, null], `${name} must match`)
}
